// Declarative settings: a feature describes a section as data and SettingsSection
// renders it. All strings are i18n keys, resolved at render time.

export type SettingsFieldValue = boolean | number | string | undefined

// Kind of control a field renders as. An enum (not a string literal) so new control
// types are added in one place and the renderer can switch on them exhaustively.
export enum SettingsFieldType {
  TOGGLE = 'toggle'
}

export type SettingsField = {
  key: string // unique within its section; used as the value-map key
  type: SettingsFieldType
  labelKey: string
  descriptionKey?: string
  disabled?: boolean
  hidden?: boolean // skipped by the renderer
}

export type SettingsSectionSchema = {
  id: string
  titleKey: string
  descriptionKey?: string
  fields: SettingsField[]
}

// Flat map of field key -> current value.
export type SettingsValues = Record<string, SettingsFieldValue>
